import React, { useState } from 'react';
import { bool, func, object, oneOf, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { findOptionsByFilterLabel, findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_DRAFT } from '../../util/types';
import {
  Button,
  InlineTextButton,
  ListingLink,
  Modal,
  NamedLink,
  UpdatedInvoice,
} from '../../components';
import { EditListingDescriptionForm } from '../../forms';
import config from '../../config';

import css from './EditListingDescriptionPanel.module.css';
import HelpAndContact from '../HelpAndContact/HelpAndContact';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { apiBaseUrl } from '../../util/api';
import axios from 'axios';
import { convertUnitToSubUnit, unitDivisor } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { withRouter } from 'react-router';
import { createSlug } from '../../util/urlHelpers';

const { Money } = sdkTypes;

const EditListingDescriptionPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    formApi,
    form,
    userNativeLang,
    onManageDisableScrolling,
    params,
    history,
  } = props;
  const tab = params.tab;
  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);

  const { description, title, publicData } = currentListing.attributes;
  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const categoryOptions = findOptionsForSelectFilter('category', config.custom.filters);
  const subcategoryOptions = findOptionsByFilterLabel('Subcategory', config.custom.filters);

  //in case the category and sub-category of a published listing is changed

  const getData = async jobCategories => {
    const response = await axios.get(
      `${apiBaseUrl()}/api/rates/${jobCategories[0].category}/${jobCategories[0].subCategory}`
    );

    const priceFromSubCategory = response?.data?.basePrice;
    const commissionRate = response?.data?.percentageValue;

    const basePrice =
      priceFromSubCategory !== null
        ? new Money(
          convertUnitToSubUnit(priceFromSubCategory, unitDivisor(config.currency)) || 0,
          config.currency
        )
        : undefined;

    const clientPriceVal = priceFromSubCategory + (priceFromSubCategory * commissionRate) / 100;
    return {
      basePrice,
      clientPrice: {
        amount: convertUnitToSubUnit(clientPriceVal, unitDivisor(config.currency)),
        currency: config.currency,
      },
    };
  };

  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingDescriptionPanel.title"
    />
  ) : (
    <FormattedMessage id="EditListingDescriptionPanel.ListYourJob" />
  );
  const create = (title, subtitle) => {
    const newKeywordArr = [];
    const titleLen = title.length;
    for (let i = 1; i <= titleLen; i++) {
      newKeywordArr.push(title.substring(0, i));
    }
    const subtitleLen = subtitle.length;
    for (let i = 1; i <= subtitleLen; i++) {
      newKeywordArr.push(subtitle.substring(0, i));
    }
    return newKeywordArr;
  };

  const certificateOptions = findOptionsForSelectFilter('certificate', config.custom.filters);

  const updatePrice = async () => {
    if (currentListing?.id?.uuid) {
      await axios
        .post(
          `${apiBaseUrl()}/api/stripe/createOrUpdatePaymentIntent`,
          {
            listingId: currentListing?.id?.uuid,
          },
          { withCredentials: true }
        )
        .then(res => {
          setShowInvoiceModal(true);
        })
        .catch(err => console.log(78888, err));
    }
  };
  let priceMayBe = null;
  let clientPriceMayBe = null;

  return (
    <div className={classes}>
      <HelpAndContact />
      <div className={css.editHeadingDiv}>
        <h1 className={css.title}>{panelTitle}</h1>
        {listing?.id?.uuid && isPublished && (
          <div>
            <NamedLink
              name="ListingPage"
              params={{
                id: listing?.id?.uuid,
                slug: createSlug(listing?.attributes?.title || ''),
              }}
            >
              <FormattedMessage id="EditListing.GoToListing" />
            </NamedLink>
          </div>
        )}
      </div>
      <EditListingDescriptionForm
        className={css.form}
        initialValues={{
          title,
          description,
          jobCategories: publicData.jobCategories,
          workerYouNeed: publicData.workerYouNeed,
          certificate: publicData.certificate,
        }}
        saveActionMsg={submitButtonText}
        onSubmit={async values => {

          const { title, description, workerYouNeed, jobCategories } = values;
          const { category, subCategory } = jobCategories[0];

          const djobCategory = categoryOptions.find(c => c.value === category);
          const djobSubCategory = subcategoryOptions[`${category}Subcategory`].find(
            c => c.value === subCategory
          );

          if (
            currentListing?.attributes?.price &&
            (values?.jobCategories?.[0].category !== publicData?.jobCategories?.[0].category ||
              values?.jobCategories?.[0].subCategory !== publicData?.jobCategories?.[0].subCategory)
          ) {

            const newPriceData = await getData(values?.jobCategories);

            priceMayBe = { price: newPriceData.basePrice };
            clientPriceMayBe = {
              percentageValue: null,
              clientPrice: newPriceData.clientPrice,
            };
          }

          let gigId = currentListing?.attributes?.publicData?.gigId
            ? currentListing?.attributes?.publicData?.gigId
            : null;
          if (!currentListing?.attributes?.publicData?.gigId) {
            const url = `${apiBaseUrl()}/api/user/customid/listing`;
            await axios
              .post(url)
              .then(resp => {
                const { customId } = resp.data;
                gigId = customId;
              })
              .catch(e => {
                log.error(e, 1236554);
              });
          }

          const updateValues = {
            title: title.trim(),
            description,
            ...priceMayBe,
            publicData: {
              gigId,
              workerYouNeed,
              jobCategories,
              searchJobcategory: [category],
              searchJobsubCategory: [subCategory],
              ...clientPriceMayBe,
              keyword: create(category, subCategory),
              djobCategory,
              djobSubCategory,
            },
            privateData: {
              shouldIncludeRemaingWorkerInRrefund: false,
            },
          };

          await onSubmit(updateValues);

          if (currentListing?.attributes?.state === 'published') {
            await axios
              .patch(
                `${apiBaseUrl()}/api/timeStatement/updateListingDetails`,
                {
                  listingId: currentListing?.id?.uuid,
                  providerId: currentListing?.author?.id?.uuid,
                },
                { withCredentials: true }
              )
              .then(res => {
              })
              .catch(err => console.log(78888, err));
          }

          if (
            (currentListing?.attributes?.state === 'published' &&
              currentListing?.attributes?.price &&
              values?.jobCategories?.[0].category !== publicData?.jobCategories?.[0].category) ||
            values?.jobCategories?.[0].subCategory !== publicData?.jobCategories?.[0].subCategory
          ) {
            updatePrice();
          }
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        certificateOptions={certificateOptions}
        formApi={form}
        userNativeLang={userNativeLang}
      />

      <Modal
        id="EditListingContactForm.agreeTermsConditions"
        isOpen={!!showInvoiceModal}
        onClose={() => {
          setShowInvoiceModal(false);
          setShowInvoice(false);
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
        containerClassName={css.invoiceModal}
      >
        <div className={css.modalContent}>
          <span className={css.invoiceTitle}>
            <FormattedMessage id="UpdatedInvoice.updatePricing" />
          </span>
          <span className={css.infoSpan}>
            <FormattedMessage id="UpdatedInvoice.infoText" />
          </span>
          <div>
            {!!showInvoiceModal && showInvoice === true ? (
              <UpdatedInvoice
                listing={currentListing}
                tab={tab}
                setShowInvoiceModal={setShowInvoiceModal}
                userNativeLang={userNativeLang}
              />
            ) : null}
            {showInvoice === true ? (
              <InlineTextButton
                className={css.viewHideInvoice}
                type="button"
                onClick={() => setShowInvoice(false)}
              >
                <FormattedMessage id="UpdatedInvoice.hideInvoice" />
              </InlineTextButton>
            ) : null}
          </div>
          {showInvoice === false ? (
            <InlineTextButton
              className={css.viewHideInvoice}
              type="button"
              onClick={() => setShowInvoice(true)}
            >
              <FormattedMessage id="UpdatedInvoice.viewInvoice" />
            </InlineTextButton>
          ) : null}

          <div className={css.ButtonContainer}>
            <Button
              type="button"
              className={css.cancelBtn}
              onClick={() => {
                history.push(
                  createResourceLocatorString('EditListingPage', routeConfiguration(), {
                    id: listing?.id?.uuid,
                    slug: createSlug(listing?.attributes?.title),
                    type: 'edit',
                    tab: 'pricing',
                  })
                );
              }}
            >
              <FormattedMessage id="UpdatedInvoice.PricingTab" />
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

EditListingDescriptionPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingDescriptionPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default compose(withRouter)(EditListingDescriptionPanel);

